import React, { useCallback, useEffect, useState } from "react";
import { api, formatApiError } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { toast } from "sonner";

const fmt = (v) => (v === null || v === undefined ? "—" : typeof v === "object" ? JSON.stringify(v) : String(v));

function Changes({ old, next }) {
  const keys = Array.from(new Set([...Object.keys(old || {}), ...Object.keys(next || {})]));
  if (!keys.length) return null;
  return (
    <div className="text-xs text-neutral-600 mt-1 space-y-0.5">
      {keys.map((k) => (
        <div key={k}>
          <span className="font-semibold">{k}</span>: <span className="line-through text-neutral-400">{fmt(old?.[k])}</span> → {fmt(next?.[k])}
        </div>
      ))}
    </div>
  );
}

export default function AuditLog() {
  const [rows, setRows] = useState([]);
  const [billNo, setBillNo] = useState("");
  const load = useCallback(async (bill) => {
    try {
      const { data } = await api.get("/audit-log", { params: bill ? { bill_number: bill } : {} });
      setRows(data);
    } catch (e) {
      toast.error(formatApiError(e));
    }
  }, []);
  useEffect(() => { load(""); }, [load]);
  return (
    <div className="p-8 lg:p-14 max-w-[1200px] mx-auto">
      <div className="text-[11px] uppercase tracking-[0.35em] text-neutral-500">Owner only</div>
      <h1 className="font-display text-5xl font-bold tracking-tight mt-2 mb-8">Audit log</h1>
      <form className="flex gap-2 mb-6 max-w-md" onSubmit={(e) => { e.preventDefault(); load(billNo.trim()); }}>
        <Input value={billNo} onChange={(e) => setBillNo(e.target.value)} placeholder="Filter by bill number" className="hygenix-input" data-testid="audit-filter-input" />
        <button className="btn-primary py-2 text-sm" data-testid="audit-filter-btn">Filter</button>
      </form>
      <div className="card-surface p-6" data-testid="audit-list">
        {rows.length === 0 && <div className="text-neutral-500 text-sm">No entries yet.</div>}
        {rows.map((r) => (
          <div key={r.id} className="py-3 border-t border-neutral-100 first:border-t-0" data-testid={`audit-row-${r.id}`}>
            <div className="text-sm flex flex-wrap gap-x-3">
              <span className="font-mono-num text-neutral-500">{new Date(r.at).toLocaleString("en-IN", { timeZone: "Asia/Kolkata" })}</span>
              <span className="font-semibold">{r.user}</span>
              <span className="chip bg-neutral-100 text-neutral-700">{r.action.replace(/_/g, " ")}</span>
              <span className="font-mono-num">{r.bill_number}</span>
            </div>
            <Changes old={r.old} next={r.new} />
          </div>
        ))}
      </div>
    </div>
  );
}
